import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Spinner,
  Alert,
  FormText,
  Button as ReactstrapButton
} from "reactstrap"
import { Button } from "../Reactstrap_Components/Button"
import { confirmSignUp } from "../../utils/auth.utils"
import { Auth } from "aws-amplify"

const VerifyEmail = ({ isModalOpen, formData }) => {
  const history = useHistory(),
    [code, setCode] = useState(""),
    [loading, setLoading] = useState(false),
    [error, setError] = useState(""),
    [resendTimer, setResendTimer] = useState(0),
    [isResending, setIsResending] = useState(false)

  useEffect(() => {
    let interval = null
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer(prev => prev - 1)
      }, 1000)
    }
    return () => {
      if (interval) clearInterval(interval)
    }
  }, [resendTimer])

  const confirm = async () => {
    const { email, password } = formData
    try {
      error && setError("")
      setLoading(true)
      await confirmSignUp(email, password, code)
      history.push("/index?signup-success=1")
    } catch (error) {
      setError(error.message)
      setLoading(false)
    }
  }

  const handleCodeChange = event => {
    setCode(event.target.value)
  }

  const handleResendCode = async () => {
    const { email } = formData
    try {
      error && setError("")
      setIsResending(true)
      await Auth.resendSignUp(email)
      setIsResending(false)
      setResendTimer(60)
    } catch (error) {
      setError(error.message)
      setIsResending(false)
    }
  }

  return (
    <Modal isOpen={isModalOpen} backdrop="static">
      <ModalHeader>Verify Email</ModalHeader>
      {error && (
        <Alert color="danger" data-testid="confirm-code-error">
          {error}
        </Alert>
      )}
      <ModalBody>
        Thank you for signing up!
        <p className="py-2">
          We need you to verify your email to complete your registration. Please check your email and paste verification
          code below:
        </p>
        <Input
          type="text"
          name="code"
          id="code"
          data-testid="code"
          value={code}
          onChange={handleCodeChange}
          placeholder="e.g. 123456"
        />
        <ReactstrapButton
          color="link"
          className="resend-code p-0 always-underline"
          onClick={handleResendCode}
          disabled={isResending || resendTimer > 0}
        >
          {isResending ? "Resending..." : resendTimer > 0 ? `Resend Code (${resendTimer}s)` : "Resend Code"}
        </ReactstrapButton>
        <FormText color="muted">
          Please check your email for the confirmation code. Contact help@traindex.io for help.
        </FormText>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={code.length < 6 || loading}
          data-testid="confirm-code-btn"
          className="purple_btn flex-grow-1 text-white"
          bgColor="#5E216B"
          onClick={confirm}
        >
          {loading && <Spinner size="sm" className="mx-1 text-white" />}Confirm
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default VerifyEmail
